import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { getMetaFromTokenURI, getIpfsUrl } from "../utils/meta_in_token";

const fallbackGateways = [
  "https://cloudflare-ipfs.com/ipfs/",
  "https://gateway.pinata.cloud/ipfs/",
  "https://dweb.link/ipfs/",
  "https://ipfs.io/ipfs/",
  "https://teal-traditional-pig-34.mypinata.cloud/ipfs/",
];

const NFTCard = ({ item, onClick }) => {
  const [meta, setMeta] = useState(null);
  const [gatewayIndex, setGatewayIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [ipfsHash, setIpfsHash] = useState("");

  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const res = await getMetaFromTokenURI(item.tokenURI);
        setMeta(res);

        const rawImage = res?.image;
        if (rawImage) {
          const normalized = rawImage
            .replace("ipfs://", "")
            .replace(/^https?:\/\/[^/]+\/ipfs\//, "");
          setIpfsHash(normalized);
        }
      } catch (err) {
        console.error("메타데이터 로드 실패:", err);
      } finally {
        setLoading(false);
      }
    };
    loadMetadata();
  }, [item.tokenURI]);

  const imageUrl = ipfsHash
    ? `${fallbackGateways[gatewayIndex]}${ipfsHash}`
    : "/default.png";

  return (
    <Card
      onClick={onClick}
      sx={(theme) => ({
        cursor: "pointer",
        bgcolor: theme.palette.background.paper,
        borderRadius: 3,
        transition: "all 0.3s ease",
        color: theme.palette.text.primary,
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
        },
      })}
    >
      {loading ? (
        <Box height={220} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box
          component="img"
          src={imageUrl}
          alt={meta?.name || item.name}
          height={220}
          width="100%"
          sx={{
            objectFit: "cover",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
          }}
          crossOrigin="anonymous"
          onError={() => {
            if (gatewayIndex < fallbackGateways.length - 1) {
              setGatewayIndex((prev) => prev + 1);
            }
          }}
        />
      )}

      <CardContent>
        <Typography variant="h6" fontWeight="bold" noWrap>
          {meta?.name || item.name || "이름 없음"}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {item.creator ? `by ${item.creator}` : "by Anonymous"}
        </Typography>
        <Box mt={1} display="flex" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">❤️ {item.liked}</Typography>
          <Typography variant="caption" color="text.secondary">👁 {item.views}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NFTCard;

